var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M1.357 5.286A.357.357 0 0 1 1 4.929V2.786a.357.357 0 0 1 .714 0v1.086C2.515 2.145 4.225 1 6.18 1 8.48 1 10.46 2.582 10.99 4.847l-.007.002c.006.026.016.051.016.08 0 .197-.16.357-.357.357a.351.351 0 0 1-.34-.278l-.008.002c-.454-1.94-2.147-3.296-4.116-3.296-1.816 0-3.383 1.158-3.975 2.857H3.5a.357.357 0 0 1 0 .715H1.357zm9.286 1.428c.197 0 .357.16.357.357v2.143a.357.357 0 0 1-.714 0V8.128C9.484 9.856 7.774 11 5.82 11 3.518 11 1.54 9.418 1.01 7.153l.007-.002C1.01 7.125 1 7.1 1 7.071c0-.197.16-.357.357-.357.169 0 .304.12.34.277l.008-.001c.454 1.94 2.146 3.296 4.116 3.296 1.815 0 3.383-1.158 3.975-2.857H8.5a.357.357 0 0 1 0-.715h2.143z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.4424c9f6.svg";
export { ForwardRef as ReactComponent };